export function user(state) {
  return state.user;
}
